import { Typography, Button, Card } from 'antd';

const { Title, Paragraph } = Typography;

const banners = [
    {
        title: 'Community Feedback',
        description: 'Get the latest updates and feedback from the community.',
        link: 'https://t.me/kaskeeper_official',
        linkText: 'View In Telegram',
    },
    {
        title: 'Dapp Open-Source Code',
        description: 'View the Dapp demo example',
        link: 'https://github.com/scalebit/KasKeeper_Dapp',
        linkText: 'View in Github',
    },
    {
        title: 'Discover Kaspa',
        description: 'Learn more about the Kaspa ecosystem and its innovative blockchain technology.',
        link: 'https://kaspa.org',
        linkText: 'Visit Kaspa',
    },
    {
        title: 'Join the KEF',
        description: 'Get involved with the Kaspa Ecosystem Foundation and contribute to the community.',
        link: 'https://kaspa.org/crescendo-hard-fork-roadmap-10bps/',
        linkText: 'Join Now',
    },
    {
        title: 'KRC20 Tokens',
        description: 'Explore KRC20 tokens and their functionalities within the Kaspa network.',
        link: 'https://kas.fyi/krc20-tokens',
        linkText: 'Explore Tokens',
    },
];

const H5 = () => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: '80vh',
                padding: '20px',
                backgroundColor: '#fff',
            }}
        >
            <Title level={2} style={{ marginTop: '6vh', color: '#00c4b4', textAlign: 'center' }}>
                KasKeeper Eco
            </Title>
            <Paragraph style={{ textAlign: 'center', maxWidth: '600px', marginBottom: '30px' }}>
                Explore the Latest Kaspa ecosystem News.
            </Paragraph>
            <div style={{ width: '100%', maxWidth: '600px' }}>
                {banners.map((banner, index) => (
                    <Card
                        key={index}
                        style={{
                            marginBottom: '20px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        }}
                        bodyStyle={{ padding: '15px' }}
                    >
                        <Title level={4}>{banner.title}</Title>
                        <Paragraph>{banner.description}</Paragraph>
                        <Button type="primary" style={{ backgroundColor: '#00c4b4', borderColor: '#00c4b4' }}>
                            <a href={banner.link} target="_blank" rel="noopener noreferrer">
                                {banner.linkText}
                            </a>
                        </Button>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default H5;